<template>
  <Slide
    :width="responsivewidth"
    :closeOnNavigation="true"
    right
    :crossIcon="false"
  >
    <router-link to="/">
      <h4 class="NiceFontMenu" style="color: white" href="#">Home</h4>
    </router-link>
    <router-link to="/about">
      <h4 class="NiceFontMenu" style="color: white" href="#">About</h4>
    </router-link>
    <router-link to="/services">
      <h4 class="NiceFontMenu" style="color: white" href="#">Services</h4>
    </router-link>
    <router-link to="/SuccessStory">
      <h4 class="NiceFontMenu" style="color: white" href="#">
        Success Stories
      </h4>
    </router-link>
    <router-link to="/order-book">
      <h4 class="NiceFontMenu" style="color: white" href="#">Order Book</h4>
    </router-link>
    <router-link to="/media">
      <h4 class="NiceFontMenu" style="color: white" href="#">Media</h4>
    </router-link>
    <router-link to="/ContactForm">
      <h4 class="NiceFontMenu" style="color: white" href="#">Contact</h4>
    </router-link>
  </Slide>
</template>

<script>
import { Slide } from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`

export default {
  name: "RightMenu",
  components: {
    Slide,
  },
  computed: {
    responsivewidth() {
      if (window.innerWidth >= 768) return "300";
      else return "200";
    },
  },
};
</script>

<style lang="scss">
.bm-burger-button {
  top: 26px !important;
  z-index: 100 !important;
}
.bm-overlay {
  background: white;
}
.bm-menu {
  background-color: black !important;
}
.bm-item-list {
  color: #b8b7ad;
  font-size: 23px;
  font-style: italic;
}
// .bm-item-list > * {
//   display: flex;
//   text-decoration: none;
//   padding: 1.2em;
// }
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}
</style>
